//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  setup() {
    const colorCheckbox = ['primary', 'secondary', 'success', 'info', 'warning', 'error']

    return { colorCheckbox }
  },
}
